export default __webpack_public_path__ + "images/9147fc0e00ad70838dc1cb07fbdc5a00.svg";